export const CONFIRM_PASSWORD = 'CONFIRM_PASSWORD';
export const SAVE_PASSWORD = 'SAVE_PASSWORD';
export const FIELD_CHANGE = 'FIELD_CHANGE';
export const BOOTSTRAP_TOKEN = 'BOOTSTRAP_TOKEN';